import Page from '@cinch/oxd-pages/manufacturer/src'
import { ManufacturerPageProps } from '@cinch/oxd-pages/manufacturer/src/manufacturer.component'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import htmlSerializer, { linkResolver } from '@somo/oxd-apps-www/src/utils/html-serializer'
import { navigate } from 'gatsby'
import { RichText } from 'prismic-reactjs'
import React from 'react'
import SEO, { Breadcrumb } from '../components/seo'

export interface ManufacturerPrismicData {
  body: any
  _meta: {
    uid: string
  }
}

interface ManufacturerInfo extends Exclude<ManufacturerPageProps, 'bodyText'>, ManufacturerPrismicData {}

interface ManufacturerArticle {
  _meta: {
    uid: string
    firstPublicationDate: string
  }
  id: string
  lead_paragraph: any[]
  title: string
  main_image: any
}

interface ManufacturerData {
  manufacturerInfo: ManufacturerInfo
  articles: ManufacturerArticle[]
  jargon: Array<{
    question: string
    summary: string
    _meta: {
      id: string
      uid: string
    }
  }>
}

interface ManufacturerPage extends Cinch.SitePage {
  pageContext: {
    data: ManufacturerData
    i18n: Cinch.WebAppTranslations['manufacturer']
  }
}

const Manufacturer: React.FC<ManufacturerPage> = ({ location, pageContext }) => {
  const { data, i18n } = pageContext

  if (!data) {
    if (typeof window !== 'undefined') {
      navigate('/find-vehicle')
    }

    return null
  }

  const { manufacturerInfo, articles, jargon } = data
  const bodyText = RichText.render(manufacturerInfo.body, linkResolver, htmlSerializer)
  const formattedArticles = articles.map(
    ({ _meta: { uid, firstPublicationDate }, lead_paragraph, title, main_image }) => ({
      id: uid,
      featured: false,
      headline: title,
      datePublished: firstPublicationDate,
      description: (lead_paragraph || [{ text: '' }])[0].text,
      image: main_image && main_image.url,
    }),
  )
  const mappedJargon = jargon.map(({ _meta: { id, uid }, ...rest }) => ({ id, uid, ...rest }))

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push({
      item: pageUrl,
      name: `${manufacturerInfo.manufacturerName} used cars for sale`,
    })
  }

  return (
    <>
      <SEO
        breadcrumbs={breadcrumbs}
        title={`Used ${manufacturerInfo.manufacturerName} Cars For Sale`}
        desc={`Find cinch’s full range of available used cars from ${manufacturerInfo.manufacturerName} for sale in your area here, all less than 7 years old and under 70,000 miles.`}
      />
      <Page {...manufacturerInfo} i18n={i18n} guides={formattedArticles} jargon={mappedJargon} bodyText={bodyText} />
    </>
  )
}

export default Manufacturer
